import {AxiosResponse} from 'axios'
import {axios} from '@/_metronic/helpers/network/Axios'
import {BaseRequest} from '@/_metronic/helpers/crud-helper/base-request'
import { EmployeeQueryResponse, FilterEmployee } from '@/app/modules/human-resources/employee/core/_models'

const HR_API_URL = '/hr-services'
const GET_EMPLOYEE = '/employee/list'
const GET_EMPLOYEE_WITHOUT_PERBANTUAN = '/employee/list-without-perbantuan'

const getEmployeeDropdown = (
  body: BaseRequest<FilterEmployee>
): Promise<EmployeeQueryResponse> => {
  return axios
    .post(`${HR_API_URL}${GET_EMPLOYEE}`, body)
    .then((d: AxiosResponse<EmployeeQueryResponse>) => d.data)
}

const getEmployeeWithoutPerbantuanDropdown = (
  body: BaseRequest<FilterEmployee>
): Promise<EmployeeQueryResponse> => {
  return axios
    .post(`${HR_API_URL}${GET_EMPLOYEE_WITHOUT_PERBANTUAN}`, body)
    .then((d: AxiosResponse<EmployeeQueryResponse>) => d.data)
}

export {getEmployeeDropdown, getEmployeeWithoutPerbantuanDropdown}